/* TM Pet Store — facets.js (collection & search pages only) */
(() => {
  'use strict';

  const theme = (window.theme = window.theme || {});
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const debounce = (fn, wait = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };
  const mqDesktop = window.matchMedia('(min-width: 990px)');

  /* ---------------------------------------------------------------------
     Collection filters & sorting
     --------------------------------------------------------------------- */
  const facetsForm = $('[data-facets-form]');
  const buildFacetUrl = (form) => {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (String(value).trim() !== '') params.append(key, value);
    });
    const sort = $('[data-sort-select]');
    if (sort) params.set('sort_by', sort.value);
    return `${form.getAttribute('action')}?${params.toString()}`;
  };
  if (facetsForm) {
    const apply = debounce(() => (window.location.href = buildFacetUrl(facetsForm)), 500);
    facetsForm.addEventListener('change', () => {
      if (mqDesktop.matches) apply();
    });
    facetsForm.addEventListener('submit', (e) => {
      e.preventDefault();
      window.location.href = buildFacetUrl(facetsForm);
    });
  }
  const sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      if (facetsForm) {
        window.location.href = buildFacetUrl(facetsForm);
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
